import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { NotFound } from 'components'
import env from 'env'
import { isAuthenticatedSelector, login } from '../authSlice'

const LoginPage = () => {
    const history = useHistory()
    const dispatch = useDispatch()
    const isAuthenticated = useSelector(isAuthenticatedSelector)
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')

    const submit = (e) => {
        e.preventDefault()
        dispatch(login({ username: email, password }))
    }

    useEffect(() => {
        if (isAuthenticated) {
            history.push('/')
        }
    }, [history, isAuthenticated])

    if (env.isProduction || env.isAcceptance) {
        return <NotFound />
    }

    return (
        <form onSubmit={submit}>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label htmlFor="username"><b>Username</b></label>
            <input
                placeholder="Enter Email"
                name="email"
                required
                onChange={(e) => setEmail(e.target.value)}
            />

            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label htmlFor="password"><b>Password</b></label>
            <input
                type="password"
                placeholder="Enter Password"
                name="password"
                required
                onChange={(e) => setPassword(e.target.value)}
            />

            <button type="submit">Login</button>
        </form>
    )
}

export default LoginPage
